module.exports = "<svg viewBox=\"0 0 30 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_3897_5903)\"><path d=\"M0 0H27C28.6569 0 30 1.34315 30 3V41C30 42.6569 28.6569 44 27 44H0V0Z\" fill=\"#1BE0A8\"></path><path d=\"M9.505 20.3999L15.005 25.8999L20.505 20.3999H9.505Z\" fill=\"white\"></path></g><defs><clipPath id=\"clip0_3897_5903\"><rect width=\"30\" height=\"44\" fill=\"white\"></rect></clipPath></defs></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/select_box_caret44.svg
// module id = 5Pug
// module chunks = 1